angular.module('rjmNg.services').factory 'categoryCache', [
  "$http"
  "$timeout"
  "$q"
  "app"
  "dateService"
  "$url"
  "rjql"
  "rjqlStringConstants"
  (
    $http
    $timeout
    $q
    app
    dateService
    $url
    rjql
    rjqlStringConstants
  ) ->
    _cache = {}
    _promises = {}

    DELIM = String.fromCharCode(31)
    CATEGORY_VALUES_LIMIT = 2000 #Corresponds to LSColumnValueList.php TOO_MANY_RESULTS_THRESHOLD
    RJQL_VERSION = 1.0

    _formatCategoryObj = (data) ->
      obj = {}
      results = []
      for label, rows of data.resultValues
        results.push
          id: label
          text: if rows? then label + " (" + rows + " rows)" else label
      obj.categoryValues = results
      obj.tooManyResults = data.tooManyResults or false
      return obj

    _filterCategoryObj = (data, searchQuery) ->
      categoryValues: data.categoryValues.filter(
        (val) ->
          val.id.toLowerCase().indexOf(searchQuery.toLowerCase()) isnt -1
      )
      tooManyResults: data.tooManyResults or false

    _parseGAvalues = (data) ->
      result =
        categoryValues: []
        tooManyResults: false

      if data?.rows?
        if data.rows.length >= CATEGORY_VALUES_LIMIT
          result.tooManyResults = true
        else
          result.categoryValues = data.rows.map(
            (row) ->
              id: row.name.toString()
              text: row.name.toString()
          )

      return result

    get = (sid, searchQuery, timeoutDeferred) ->
      unless typeof searchQuery is 'string'
        searchQuery = ''

      params =
        id: sid
        q: searchQuery

      timeoutDeferred ?= $q.defer()
      deferred = $q.defer()

      # If this is an unbound dimension, return an empty list
      if sid is rjqlStringConstants.RJQL_UNBOUND
        promise = $timeout ->
        return deferred.promise.then ->
          deferred.resolve([])

      $timeout ->
        cacheIdBase = "#{sid}#{DELIM}"
        cacheId = cacheIdBase + searchQuery

        if _cache[cacheId]?
          deferred.resolve(_cache[cacheId])
        else if searchQuery isnt "" and _cache[cacheIdBase]? and not _cache[cacheIdBase].tooManyResults
          obj = _filterCategoryObj(_cache[cacheIdBase], searchQuery)
          _cache[cacheId] = obj
          deferred.resolve(_cache[cacheId])
        else if _promises[cacheId]?
          return _promises[cacheId]
        else
          promise = $http
            method: "GET"
            url: $url("/client/#{app.getClientId()}/lscolumn/#{sid}/categoryvalues")
            params: params
            timeout: timeoutDeferred.promise
          .then ({data}) ->
            obj = _formatCategoryObj(data)
            _cache[cacheId] = obj
            deferred.resolve(_cache[cacheId])
          .catch (error) ->
            obj = _formatCategoryObj({})
            deferred.resolve(obj)
          .finally () ->
            delete _promises[cacheId]

          _promises[cacheId] = deferred.promise

        return deferred.promise

    getGa = (metric, dimension, startDate, endDate, searchQuery) ->
      unless typeof searchQuery is 'string'
        searchQuery = ''

      tempMetric = angular.copy(metric)
      apiConnId = tempMetric.id[0]
      trendId = tempMetric.numericalId
      deferred = $q.defer()

      $timeout ->
        cacheIdBase = "#{apiConnId}#{DELIM}#{trendId}#{DELIM}#{dimension.column_id}#{DELIM}"
        cacheId = cacheIdBase + searchQuery

        if _cache[cacheId]?
          deferred.resolve(_cache[cacheId])
        else if searchQuery isnt "" and _cache[cacheIdBase]? and not _cache[cacheIdBase].tooManyResults
          obj = _filterCategoryObj(_cache[cacheIdBase], searchQuery)
          _cache[cacheId] = obj
          deferred.resolve(_cache[cacheId])
        else if _promises[cacheId]?
          return _promises[cacheId]
        else
          tempMetric.dimensions = [dimension]
          tempMetric.dimensionValues = []
          if searchQuery is ''
            tempMetric.filters =
              restrictions: []
              sequence:
                string: null
                errorMessage: null
          else
            tempMetric.filters =
              restrictions: [
                errorMessage: null
                left: dimension
                op: "IN"
                right: searchQuery
              ]
              sequence:
                string: "[A]"
                syntaxTree: 0
                errorMessage: null
          source = [tempMetric]
          rows = [dimension]
          columns = null #No time interval
          timerange = dateService.getStaticTimeRange(startDate, endDate, RJQL_VERSION)
          range = null #Used for cohort, not available for GA metrics

          query = rjql.generateQuery(source, rows, columns, timerange, range, false, RJQL_VERSION)

          rjql.runQuery(
            app.getClientId()
            query
            null
            RJQL_VERSION
            app.hasFeatureFlag('RJQL_SERVICE_DEBUG')
          ).then ({data})->
            _cache[cacheId] = _parseGAvalues(data)
            deferred.resolve(_cache[cacheId])
          .catch (error) ->
            obj = _parseGAvalues(null)
            deferred.resolve(obj)
          .finally () ->
            delete _promises[cacheId]

          _promises[cacheId] = deferred.promise

        return deferred.promise

    getByDimension = (dimension, keyMetric=null, searchQuery="") ->
      if keyMetric? and keyMetric.isGaMetric
        # We use 2 years here because GA not supporting All-Time renage
        start = moment().subtract(2, 'years').format('YYYY-MM-DD')
        end = moment().subtract(1, 'days').format('YYYY-MM-DD')
        return getGa(keyMetric, dimension, start, end, searchQuery)
      else
        return get(dimension.column_id, searchQuery)

    {
      get
      getGa
      getByDimension
    }

  ]
